import getSettingOptionList, { itemList, settingList } from './settings.options';

export const storageLabels = {
  settingStorage: 'settingStorage',
  timeLimit: 'timeLimit',
  timeDayMutation: 'timeDayMutation',
  soundActive: 'soundActive',
  age: 'age',
  language: 'language',
};

const storage = localStorage.getItem(storageLabels.settingStorage);
const playlistStorage = localStorage.getItem('playlist');
let storagePlaylist = playlistStorage !== null ? JSON.parse(playlistStorage) : [];

// eslint-disable-next-line import/no-mutable-exports
export let settingStorageJson = storage !== null
  ? JSON.parse(String(localStorage.getItem(storageLabels.settingStorage))).settingStorageJson
  : [];

export default {
  // soundIsSet() {
  //   const index = settingStorageJson.findIndex((x) => x.item.type === itemList.other);

  //   if (index >= 0) {
  //     return true;
  //   }

  //   return false;
  // },
  getExcludeCategoryIds(contentType) {
    if(contentType === 0 || contentType === '') {
      return [];
    }
    return settingList.find(obj => obj.itemType === 'content')?.options.filter(option => option.value !== contentType).map(obj => obj.value) || [];
  },
  playSound() {
    const index = this.findItemType(itemList.other);

    if (index !== false) {
      return settingStorageJson[index].item.play;
    }

    return false;
  },
  toogleSound() {
    const index = this.findItemType(itemList.other);

    settingStorageJson[index].item.play = !settingStorageJson[index].item.play;
    localStorage.setItem(storageLabels.settingStorage, JSON.stringify({ settingStorageJson }));
  },
  timeLimitIsSet() {
    if (this.getStorageValue(storageLabels.timeLimit) !== false) {
      this.resetTimeLimit();

      return true;
    }

    return false;
  },
  resetTimeLimit() {
    const timeLimitDaySet = Number(this.getStorageValue(storageLabels.timeDayMutation));
    const todayDay = new Date().getDay();

    if (timeLimitDaySet !== todayDay) {
      const maxTimeLimit = this.getOptionValue(itemList.time) * 60;

      localStorage.setItem(storageLabels.timeLimit, JSON.stringify(maxTimeLimit));
      localStorage.setItem(storageLabels.timeDayMutation, todayDay);
    }
  },
  playlistStorage(add, video) {
    if (add) {
      storagePlaylist.push(video);
      localStorage.setItem('playlist', JSON.stringify(storagePlaylist));
    } else {
      storagePlaylist = storagePlaylist.filter((x) => x.identifier !== video.identifier);
      localStorage.setItem('playlist', JSON.stringify(storagePlaylist));
    }
  },
  findItemType(type) {
    const index = settingStorageJson.findIndex((x) => x.item.type === type);

    if (index >= 0) {
      return index;
    }

    return false;
  },
  getSelectedOption(type) {
    const index = this.findItemType(type);

    if (index !== false) {
      return settingStorageJson[index].item.option;
    }

    return false;
  },
  getStorageValue(label) {
    const value = localStorage.getItem(label);

    if (value !== null) {
      return value;
    }

    return false;
  },
  getOptionValue(itemType) {
    const result = this.getSelectedOption(itemType);

    if (result !== false) {
      const settingItem = getSettingOptionList.find((x) => x.itemType === itemType);

      if (settingItem) {
        const optionList = settingItem.options;
        const contentValue = optionList.find((x) => x.optionId === result);

        if (contentValue) {
          if (itemType !== itemList.language) {
            return contentValue.value;
          }

          return {
            value: contentValue.value,
            codeLang: contentValue.codeLang,
          };
        }

        return false;
      }

      return false;
    }

    return false;
  },
  getAgeOptionId(item, value) {
    const option = settingList.find((x) => x.itemType === item);
    const optionValue = option.options.find((x) => x.value.minAge === value.minAge && x.value.maxAge === value.maxAge);

    return optionValue.optionId;
  },
  getOptionId(item, value) {
    const option = settingList.find((x) => x.itemType === item);
    const optionValue = option.options.find((x) => x.value === value);

    return optionValue.optionId;
  },
  removeFromSettingStorage(item) {
    if (settingStorageJson.length > 0) {
      const storageWithoutItem = settingStorageJson.filter((x) => x.item.type !== item);

      settingStorageJson = storageWithoutItem;
      localStorage.setItem(storageLabels.settingStorage, JSON.stringify({ settingStorageJson }));
    }
  }
};
